import React, {useContext, useEffect, useState} from 'react'
import { useParams } from "@reach/router";
import {getRecipeById} from "../../../services/serviceRecipe";
import {RecipeUpdateContext} from "../../../context/RecipeUpdateContext";
import RecipeUpdateList from "./RecipeUpdateList";
import {Col, Divider, Row} from "antd";
import UpdateAbstract from "./abstract/UpdateAbstract";

const RecipeUpdate = () => {
    const {recipeId} = useParams()
    const [listRender, setListRender] = useState(false)

    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId


    useEffect(() => {
        getRecipeById(recipeId)
            .then(({data}) => {
                setRecipeById(data)
                setListRender(!listRender)
            })
    }, [])

    return(
        <React.Fragment>
            {
                listRender ?
                    <Row justify={'space-between'}>
                        <Col span={20}>
                            <RecipeUpdateList />
                        </Col>
                        <Col>
                            <Divider type={'vertical'} style={{
                                height: '100%'
                            }} />
                        </Col>
                        <Col span={3}>
                            <UpdateAbstract />
                        </Col>
                    </Row>

                    : <h5>Yükleniyor...</h5>
            }
        </React.Fragment>
    )
}
export default RecipeUpdate